import React from 'react';
import { FaVideo } from 'react-icons/fa';

import {
	HOW_TO_VIDEOS_CSV,
	HOW_TO_VIDEOS_SHOPIFY,
} from '@/components/utils/constants';
import { useUser } from '@/hooks/useUser';
import { InventoryType } from '@/interfaces/api/InventoryType';

const HowToVideos: React.FC = () => {
	const { user } = useUser();

	return (
		<div className="flex flex-col h-full w-full">
			<div className="h-full bg-gray-70 p-6">
				<div className="max-w-6xl mx-auto">
					{/* Header Section */}
					<div className="mb-8">
						<div className="flex items-center gap-3 mb-4">
							<FaVideo className="text-3xl text-purpleBrand-500" />
							<h1 className="text-3xl font-bold text-gray-800">
								How-to Videos
							</h1>
						</div>
						<p className="text-lg text-gray-600">
							Watch these helpful tutorials to get the most out of your Haggles
							experience.
						</p>
					</div>

					{/* Videos Grid */}
					<div className="grid gap-8 lg:grid-cols-1 xl:grid-cols-2">
						{(user?.inventoryType === InventoryType.CSV
							? HOW_TO_VIDEOS_CSV
							: HOW_TO_VIDEOS_SHOPIFY
						).map((video, index) => (
							<div
								key={index}
								className="bg-white rounded-lg shadow-lg overflow-hidden"
							>
								{/* Video Content */}
								<div className="p-6">
									<h3 className="text-xl font-semibold text-gray-800 mb-3">
										{video.title}
									</h3>
									<p className="text-gray-600 mb-6 leading-relaxed">
										{video.description}
									</p>

									{/* Video Iframe */}
									<div className="aspect-video bg-gray-100 rounded-lg overflow-hidden">
										<iframe
											className="w-full h-full rounded-lg"
											src={video.url}
											allow="autoplay; fullscreen"
											allowFullScreen
											title={video.title}
											frameBorder="0"
										/>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default HowToVideos;
